import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const LogoutButton = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate("/"); // Redirect to home page
    };

    return (
        <button
            onClick={handleLogout}
            className="ml-4 text-sm text-red-700 underline hover:text-red-900"
        >
            Logout
        </button>
    );
};

export default LogoutButton;
